import {
	Extension,
	ExtensionProperty,
	PropertyType,
	type ReaderContext,
	type WriterContext,
} from "@gltf-transform/core";

import type {
	GLTFLoaderPlugin,
	GLTFParser,
} from "three/examples/jsm/loaders/GLTFLoader.js";

export const EXTENSION_NAME = "DPL_node_locator";

export class DPLNodeLocatorExtension implements GLTFLoaderPlugin {
	parser: GLTFParser;
	name: string = EXTENSION_NAME;

	constructor(parser: GLTFParser) {
		this.parser = parser;
	}
}

export class NodeLocatorProperty extends ExtensionProperty {
	static EXTENSION_NAME = EXTENSION_NAME;
	extensionName = EXTENSION_NAME;
	propertyType = "NodeLocator";
	parentTypes = [PropertyType.NODE];
	name = EXTENSION_NAME;

	protected init() {
		this.extensionName = EXTENSION_NAME;
		this.propertyType = "NodeLocator";
		this.parentTypes = [PropertyType.NODE];
		this.name = EXTENSION_NAME;
	}
}

export class DPLNodeLocator extends Extension {
	static EXTENSION_NAME = EXTENSION_NAME;
	extensionName = EXTENSION_NAME;

	createLocatorProperty() {
		return new NodeLocatorProperty(this.document.getGraph());
	}

	read(context: ReaderContext): this {
		for (const [nodeIndex, nodeDef] of context.jsonDoc.json.nodes?.entries() ||
			[]) {
			const extDef = nodeDef.extensions?.[EXTENSION_NAME];

			if (!extDef) {
				continue;
			}

			const locatorProperty = this.createLocatorProperty();
			context.nodes[nodeIndex].setExtension(EXTENSION_NAME, locatorProperty);
		}

		return this;
	}

	write(context: WriterContext): this {
		for (const node of this.document.getRoot().listNodes()) {
			const locatorProperty =
				node.getExtension<NodeLocatorProperty>(EXTENSION_NAME);
			if (locatorProperty) {
				const nodeIndex = context.nodeIndexMap.get(node);
				if (nodeIndex === undefined) {
					continue;
				}

				const nodeDef = context.jsonDoc.json.nodes?.[nodeIndex];
				if (!nodeDef) {
					continue;
				}

				nodeDef.extensions ??= {};
				nodeDef.extensions[EXTENSION_NAME] = {};
			}
		}

		return this;
	}
}
